import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Login|Banned Landing Page`;

export type CPBannedLandingPageLocs = 'CPBannedLandingPageTitle' | 'CPBannedLandingPageDescription';

export const cpBannedLandingPageLocs: LocDefs<CPBannedLandingPageLocs> = {
	CPBannedLandingPageTitle: {
		defaultValue: 'Account Banned',
		description: 'Title for dashboard page of candidates with banned account',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessBannedLandingPage,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPBannedLandingPageDescription: {
		defaultValue: `<p>Your account has been banned due to anomalous activity. If you have any questions, please contact support.</p>`,
		description: 'Description for dashboard page of candidates with banned account',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessBannedLandingPage,
		htmlAllowed: true,
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CPBannedLandingPageLocs>(cpBannedLandingPageLocs);
export type CPBannedLandingPageLocKeys = LocMap<CPBannedLandingPageLocs>;
